import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { formatMsisdn } from "../../../../tools/tools";
import { ShopReceipt, toman } from "../../../auxiliary/shop/ShopPage";

const FinalPayBill = () => {
	const [t] = useTranslation("global");
	const { state } = useLocation();
	return (
		<ShopReceipt
			title={t("payBill.title")}
			prefix="sp"
			rows={[
				["نوع سرویس", <>پرداخت صورتحساب</>],
				["شماره سیم کارت", <span dir="ltr">{formatMsisdn(state?.msisdn?.toString())}</span>],
				["مبلغ صورتحساب", toman(state?.amount)],
				["کد پیگیری", <span dir="ltr">{state?.purchasefollowupcode}</span>],
			]}
		/>
	);
};

export default FinalPayBill;
